// eslint-disable-next-line no-magic-numbers
type SmartPlayerEnvironment = 0 | 1 | 2 | 3 | 4;

interface SmartPlayerConstants {
   environments: {
      [environmentName: string]: SmartPlayerEnvironment;
   };
   contentType: {
      unknown: string;
      audio: string;
      image: string;
      video: string;
      youtube: string;
   };
   analytics: {
      viewEvent: string;
      viewAction: {
         FromLti: string;
         FromEmbed: string;
         FromViewPage: string;
         FromUnknown: string;
      };
   };
   imageBackgroundColor: string;
   minPlayerHeight: string;
   youtubeControls: string;
}

export default {
   environments: {
      local: 1,
      dev: 1,
      stage: 2,
      live: 3,
      test: 4
   },
   contentType: {
      unknown: 'unknown',
      audio: 'audio',
      image: 'image',
      video: 'video',
      youtube: 'youtube'
   },
   analytics: {
      viewEvent: 'View',
      viewAction: {
         FromLti: 'Viewed On LTI Page',
         FromEmbed: 'Viewed On Embed Page',
         FromViewPage: 'Viewed On The View Page',
         FromUnknown: 'Viewed From Unknown Source'
      }
   },
   imageBackgroundColor: '#f5f5f5',
   // this is roughly the height of the quizzing email required input form, seems a reasonable cut-off, else this dialog is unusable
   minPlayerHeight: '360px',
   youtubeControls: 'youtube'
} as SmartPlayerConstants;
